// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"753f01179e4eb5c91444","678":"cb7b72d4fc10ce7375f6","883":"67d166d323e1a2c2dd0a"}[chunkId] + ".js";
};